/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component } from "@angular/core";
var DatagridActionBar = (function () {
    function DatagridActionBar() {
    }
    return DatagridActionBar;
}());
export { DatagridActionBar };
DatagridActionBar.decorators = [
    { type: Component, args: [{
                selector: "clr-dg-action-bar",
                template: "\n        <ng-content></ng-content>\n    ",
                host: {
                    "[class.datagrid-action-bar]": "true"
                }
            },] },
];
/** @nocollapse */
DatagridActionBar.ctorParameters = function () { return []; };
//# sourceMappingURL=datagrid-action-bar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/datagrid-action-bar.js
// module id = 153
// module chunks = 4